const Strings = {
  SIGN_OUT: {
    SE: 'Logga ut',
    EN: 'Sign out'
  },
  SIGN_OUT_HEADER: {
    SE: 'Är du säker på att du vill logga ut?',
    EN: 'Are you sure you want to sign out?'
  },
  NO: {
    SE: 'Nej',
    EN: 'No'
  },
  YES: {
    SE: 'Ja',
    EN: 'Yes'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/MenuHeader/strings.js